import * as ACTION from './constants';

const initialState = {
  accountData: null,
  isFetching: false,
  isUpdating: false,
  isVerifying: false,
  verified: false,
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.SETTINGS_BASE:
      return {...initialState};
    case ACTION.GET_USER_DATA:
      return { ...state, isFetching: true };
    case ACTION.UPDATING_USER_DATA:
      return { ...state, isUpdating: true };
    case ACTION.SET_USER_DATA:
      return {
        ...state,
        isUpdating: false,
        accountData: action.payload,
      };
    case ACTION.STRIPE_VERIFYING:
      return {...state,
        isVerifying: true,
      };
    case ACTION.STRIPE_VERIFIED:
      return {...state,
        isVerifying: false,
        verified: action.verified,
      };
    case ACTION.STRIPE_NOT_VERIFIED:
      return {...state,
        isVerifying: false,
        verified: false,
      };
    default:
      return state;
  }
}
